import useCtrlKey from "./useCtrlKey";
import useClick from "./useClick";
import useShiftKey from "./useShiftKey";
import { useTreeStateContext } from "../contexts/TreeContext";

// Hook for group all the action key on the bot editor 'mouse click' and 'shift key'
function useActionKey() {
    const { onKeyDown, onKeyUp, ctrlKey } = useCtrlKey();
    const { onClickDown, onClickUp, pressDown } = useClick();
    const { pressShiftKey, shiftKey, changeShiftKey } = useShiftKey();

    const { zoneSelectBlocks } = useTreeStateContext();

    
    return {onKeyDown, onKeyUp, onClickDown, onClickUp, ctrlKey, pressDown, changeShiftKey, shiftKey };
}

export default useActionKey;